import { LeadFilter } from './lead-filter';

export class LeadFilterStorage {
    filter: LeadFilter;
    filterValues: Map<string, any>;

    constructor(filter: LeadFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
